export default "__VITE_ASSET__A_hkVyZ1__"